import UserAvatar from 'app/shared-components/user/UserAvatar';
import UserName from 'app/shared-components/user/UserName';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

export const Mention= ({ mention }) => {
  return (
    <Tooltip  title={<TooltipTitle user={mention.user} />}>
      <span style={{ color: 'blue' }}>@{mention.name}</span>
    </Tooltip>
  );
}

function TooltipTitle({ user }) {
  return (
    <Stack direction="row" spacing={2}> 
      <UserAvatar user={user} />
      <div>
        <div>
          <UserName user={user}/>
        </div>
        <div>
          @{user.screenName}
        </div>
      </div>
    </Stack>
  );
}

export default Mention;